import React from 'react'

const CustomerCookiesPolicy = () => {
    return (
        <div>CustomerCookiesPolicy</div>
    )
}

export default CustomerCookiesPolicy